// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__2JaUi","loader":"Loading_loader__fHWHo","rot5":"Loading_rot5__2BtBT"};